<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
};
</script>
<style lang="css">
@import url(../src/assets/fonts/font.css);
@import url("https://api.tiles.mapbox.com/mapbox-gl-js/v0.53.0/mapbox-gl.css");
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #f5f5f5;
  border-radius: 10px;
}

::-webkit-scrollbar {
  width: 4px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #fff;
  background-image: linear-gradient(
    219deg,
    rgba(10, 171, 148, 1) 35%,
    rgba(95, 188, 94, 1) 100%
  );
}
.v-btn {
  letter-spacing: 0px !important;
}
.v-application {
  font-family: Rokh !important;
  letter-spacing: 0px;
}
html {
  font-size: 16px;
  letter-spacing: 0px;
}
body {
  font-family: Rokh !important;
  direction: rtl;
  background-color: #cdcdcd;
  margin: 0;
  letter-spacing: 0px !important;
}
h1,
h2,
h3,
h4,
h5,
h6,
input,
textarea {
  font-family: Rokh !important;
}
h1 {
  font-weight: bold;
}
.wrapper {
  max-width: 900px;
  margin: 0 auto;
}
.ltr {
  direction: ltr;
}
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-small {
  font-size: 0.8em;
}
.text-xsmall {
  font-size: 0.6em;
}
.text-large {
  font-size: 1.2em;
}
.text-xlarge {
  font-size: 1.4em;
}
.text-underline {
  text-decoration: underline;
}

.text-thin {
  font-weight: 100;
}
.text-UltraLight {
  font-weight: 200;
}
.text-light {
  font-weight: 300;
}
.text-regular {
  font-weight: normal;
}
.text-medium {
  font-weight: 500;
}
.text-demibold {
  font-weight: 600;
}
.text-bold {
  font-weight: bold;
}

.text-extrabold {
  font-weight: 800;
}
.text-black {
  font-weight: 900;
}
.mapboxgl-user-location-dot::before {
  background-color: rgba(95, 188, 94, 1) !important;
}
.mapboxgl-user-location-dot {
  background-color: rgba(95, 188, 94, 1) !important;
}
.moveInUp-enter-active {
  opacity: 0;
  transition: opacity 2s ease-in;
}
.moveInUp-enter-active {
  animation: fadeIn 2s ease-in;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
.moveInUp-leave-active {
  animation: moveInUp 0.3s ease-in;
}
@keyframes moveInUp {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-400px);
  }
}
.theme--light.v-application {
  background: #e0e0e0 !important;
  color: rgba(0, 0, 0, 0.87);
}
</style>
